import { InfoCircleFilled } from '@ant-design/icons';
import { Alert } from 'antd';

import type { VirtualCardData } from '../types';

export type AlertConfig = {
  formatDate?: (date: string) => string;
  checkinLabel?: string;
  importantMessagePart1?: string;
  importantMessagePart2?: string;
  deactivatedMessage?: string;
};

type CardAlertsProps = {
  data: VirtualCardData;
  cardIsCanceled: boolean;
  cardIsDeactivated: boolean;
  alertConfig?: AlertConfig;
};

const DEFAULT_CONFIG: AlertConfig = {
  formatDate: (date) => date,
  checkinLabel: 'check-in day',
  importantMessagePart1:
    'Important: the pre-authorisation, deposit, extras or tourist tax',
  importantMessagePart2:
    "must not be made with this virtual card but with the guest's physical card.",
  deactivatedMessage:
    'VCC expire within 180 days of check-in for fraud protection. For any inquiries regarding a deactivated card, please contact your account manager.',
};

export const CardAlerts = ({
  data,
  cardIsCanceled,
  cardIsDeactivated,
  alertConfig = {},
}: CardAlertsProps) => {
  const config = { ...DEFAULT_CONFIG, ...alertConfig };

  return (
    <div className="card-description">
      {!cardIsCanceled && !cardIsDeactivated ? (
        <>
          <Alert
            className="blue-variant"
            type="info"
            message={
              <div>
                {config.importantMessagePart1}{' '}
                <span className="bold">{config.importantMessagePart2}</span>
              </div>
            }
            icon={<InfoCircleFilled />}
            showIcon
          />
          <Alert
            className="grey-variant"
            type="info"
            message={
              <div>
                The card will be chargeable from{' '}
                <span className="bold">
                  {config.checkinLabel} ({config.formatDate?.(data.checkin)})
                </span>{' '}
                and up to 6 months.
              </div>
            }
            icon={<InfoCircleFilled />}
            showIcon
          />
        </>
      ) : (
        <></>
      )}

      {cardIsDeactivated ? (
        <Alert
          className="grey-variant"
          type="info"
          message={config.deactivatedMessage}
          icon={<InfoCircleFilled />}
          showIcon
        />
      ) : (
        <></>
      )}
    </div>
  );
};
